import React from 'react'
import { ResponsivePie } from '@nivo/pie'

const HOURS_TARGET = 2000

export default function AllroadDashboardPieGraph({pending = {}, need = 0, progress=0, complete={}}) {

  const [completeHours, setCompleteHours] = React.useState(0);
  const [projectedHours, setProjectedHours] = React.useState(0);
  const [needHours, setNeedHours] = React.useState(0);
  const [progressPerc, setProgressPerc] = React.useState(0);

  const calculateProgress = (complete, projected) => {

    const goodHours = parseInt(complete + projected)
    const needHours = HOURS_TARGET - goodHours
    const progress = parseInt(goodHours/HOURS_TARGET * 100)
    setNeedHours(needHours)
    setProgressPerc(progress)
  }

  const dataProvider = async () => {
    const hoursData = await cleanData()
    await calculateProgress(hoursData.totalComplete, hoursData.totalProjected);
  }

  const cleanData = async () => {
    /** COMPLETE:
     * {"2023-12-04":{"uniqueWorkers":36,"totalHours":260.75},"2023-12-05":{"uniqueWorkers":3,"totalHours":17.5}}
     * */ 
    /** PROJECTED:
     * {"2023-12-04":{"totalHours":351},"2023-12-05":{"totalHours":307},"2023-12-06":{"totalHours":101},"2023-12-07":{"totalHours":0},"2023-12-08":{"totalHours":0},"2023-12-09":{"totalHours":0},"2023-12-10":{"totalHours":0}}
     */

    let totalComplete = 0;
    Object.keys(complete).forEach(key => {
      totalComplete += complete[key].totalHours
    })

    setCompleteHours(parseInt(totalComplete))

    let totalProjected = 0;
    Object.keys(pending).forEach(key => {
      totalProjected += pending[key].totalHours
    })

    setProjectedHours(parseInt(totalProjected))
    
    return {totalComplete: totalComplete, totalProjected: totalProjected}
  }

  React.useEffect(() => {
    dataProvider()
  },[complete, pending])

  const data = [
    {
      "id": "Pending",
      "value": projectedHours,
    },
    {
      "id": "Remaining",
      "value": needHours,
    },
    {
      "id": "Complete",
      "value": completeHours,
    },
    
  ]

  const CenteredText = ({ centerX, centerY }) => {
    return (
        <text
            x={centerX}
            y={centerY}
            textAnchor="middle"
            dominantBaseline="central"
            style={{
                fontSize: '24px',
                fontWeight: 'bold',
            }}
            fill={progressPerc > 50 ? '#0052CC' : '#cc0052'}
        >
          {progressPerc}%
        </text>
    );
  };

  return (
    <ResponsivePie
        data={data}
        margin={{ top: 60, right: 60, bottom: 60, left: 60 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        activeOuterRadiusOffset={8}
        colors={['#0052CC', '#cc0052', '#52cc00']}
        borderWidth={1}
        borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: 'color' }}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor={"white"}
        layers={[
          'arcs',
          'arcLabels',
          'arcLinkLabels',
          'legends',
          CenteredText,
      ]}
    />
  )
}
